import React, { useEffect, useState} from 'react';
import ReactLoading from 'react-loading';

export const RedirectPage = props => {
    const [redirectMsg, setRedirectMsg] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        getFriendlyName()
        .then((redirectURL)=>{
            logRedirect(redirectURL);
        });
    }, []);

    //Gets the friendly name
    const getFriendlyName = () =>{
        return new Promise((resolve, reject) =>{
            fetch(localStorage.getItem('server') + 'redirect/' + props.match.params.code + '/name', {
                method: 'GET'
            })
            .then((resp)=>{
                return resp.json();
            })
            .then((data)=>{
                if(data.status === 200 && data.name !== null){
                    setRedirectMsg('Redirecting you to ' + data.name);
                    resolve(data.redirectURL);
                } else {
                    setLoading(false);
                    throw new Error('Unable to redirect. Please try again later.');
                }
            })
            .catch((error)=>{
                setRedirectMsg('Unable to redirect. Please try again.');
            });
        });
    }

    const logRedirect = (redirectURL) =>{
        getIP()
        .then((ip)=>{
            var body = {
                'ip': ip.ip,
                'userAgent': navigator.userAgent,
            };
            
            fetch(localStorage.getItem('server') + 'redirect/' + props.match.params.code + '/log', {
                method: 'POST',
                body: JSON.stringify(body)
            })
            .then(()=>{
                window.location.replace(redirectURL);
            });
        });
    }

    const getIP = () =>{
        return new Promise((resolve, reject) => {
            fetch('https://api.ipify.org/?format=json')
            .then((response)=>{
                return response.json();
            })
            .then((data)=>{
                resolve(data);
            });
        });
    }

    return (
        <div className="container">
            <div className="loading">
                <ReactLoading hidden={!loading} type={'cylon'} color={'#61dafb'} height={300} width={300} />
                <h3 className="text-center">{redirectMsg}</h3>
            </div>
        </div>
    )
}